"use client";

import { Suspense } from "react";
import { NextIntlClientProvider, type AbstractIntlMessages } from "next-intl";
import { NavigationProgress } from "./NavigationProgress";
import { CapacitorDetector } from "./CapacitorDetector";
import { ServiceWorkerRegistrar } from "./ServiceWorkerRegistrar";
import { PushSubscriptionReconciler } from "./PushSubscriptionReconciler";
import { Toaster } from "./ui/toaster";
import { CookieConsentBanner } from "./layout/CookieConsentBanner";

interface ProvidersProps {
  children: React.ReactNode;
  locale: string;
  messages: AbstractIntlMessages;
}

export function Providers({ children, locale, messages }: ProvidersProps) {
  return (
    <NextIntlClientProvider locale={locale} messages={messages} timeZone="UTC">
      <CapacitorDetector />
      <ServiceWorkerRegistrar />
      <PushSubscriptionReconciler />
      <Suspense fallback={null}>
        <NavigationProgress />
      </Suspense>
      <Toaster />
      <CookieConsentBanner />
      {children}
    </NextIntlClientProvider>
  );
}
